import { render, staticRenderFns } from "./policyDetails.vue?vue&type=template&id=c0785e7a&scoped=true&"
import script from "./policyDetails.vue?vue&type=script&lang=js&"
export * from "./policyDetails.vue?vue&type=script&lang=js&"
import style0 from "./policyDetails.vue?vue&type=style&index=0&id=c0785e7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0785e7a",
  null
  
)

export default component.exports